import * as React from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import type { PartProps } from '../../../lib/part-props'

export function DialogPortal({ children, ...props }: PartProps<React.ComponentProps<typeof BaseDialog.Portal>>) {
  return <BaseDialog.Portal {...props}>{children}</BaseDialog.Portal>
}
